{
    "webshop_offer_voucher_correctCode": "Correct code entered",
    "webShop_howToFindId_desc": "You can find and copy your personal ID in your player profile.",
    "webShop_howToFindId_link": "Where do I find my personal ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Code is incorrect",
    "webshop_offer_voucher_enterYourCode": "Enter your personal ID",
    "webShop_unexpectedError_desc": "An unexpected error occurred, please try again later.",
    "webShop_accountBanned_desc": "Account banned!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Terms &amp; Conditions",
    "webshop_purchase_privacyPolicy": "Privacy Policy",
    "webshop_legal_1": "Legal",
    "webshop_support_1": "Support",
    "mbs_access_welcome_desc": "Welcome, {0}",
    "btn_login": "Login",
    "mbs_access_error_sessionExpired_desc": "Your session has expired. Please enter your account ID manually."
}
